import { CButton, CCard, CCardBody, CCardHeader } from "@coreui/react"
import { Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import moment from "moment"
import 'moment/locale/id'
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getAllFrameAssignment } from "src/services/Frames"

function FrameAssignmentTables() {
    const navigate = useNavigate()

    const [framesAssignment, setFramesAssignment] = useState([])

    const tableHeader = [
        { field: 'id', headerName: 'ID', width: '100' },
        { field: 'merchant_name', headerName: 'Merchant', width: '200' },
        { field: 'booth_id', headerName: 'Booth', width: '100' },
        { field: 'frame_name', headerName: 'Frame', width: '100' },
        { field: 'valid_from', headerName: 'From', width: '150' },
        { field: 'valid_until', headerName: 'Until', width: '150' },
        { field: 'sequence', headerName: 'Sequence', width: '100' },
    ]

    async function fetchFrameAssignment() {
        getAllFrameAssignment().then(response => {
            setFramesAssignment(response.data.map(item => {
                return {
                    ...item,
                    valid_from: item.valid_from ? moment(item.valid_from).locale('id').format('DD MMMM YYYY') : '-',
                    valid_until: item.valid_until ? moment(item.valid_until).locale('id').format('DD MMMM YYYY') : '-',
                }
            }))
        })
    }

    useEffect(() => {
        fetchFrameAssignment()
    }, [])

    return <>
        <CCard>
            <CCardHeader className="d-flex justify-content-between align-middle">
                Frame Assignment
                <CButton onClick={() => navigate('/frames-assignment-actions')}>
                    Assign Frame
                </CButton>
            </CCardHeader>
            <CCardBody>
                <DataGrid
                    rows={framesAssignment}
                    columns={tableHeader}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 5 }
                        },
                        sorting: {
                            sortModel: [{ field: 'id', sort: 'desc' }],
                        },
                    }}
                    pageSizeOptions={[5, 10, 20, 25]}
                    onCellDoubleClick={(e) => {
                        navigate('/frames-assignment-edit', { state: { id: e.id } })
                    }}
                />
            </CCardBody>
        </CCard>
    </>
}

export default FrameAssignmentTables